import { useEffectEvent, useLayoutEffect } from 'react'

import { type FiltersFocusType } from '@/defs/view'
import { useReduxDispatch, useReduxSelector } from '@/store/hooks'
import { viewActions } from '@/store/view'

export const useFiltersFocus = (focus: FiltersFocusType, onFocus?: () => void) => {
  const dispatch = useReduxDispatch()
  const isRequested = useReduxSelector((s) => s.view.filtersFocus === focus)
  const onFocusEvent = useEffectEvent(() => onFocus?.())

  useLayoutEffect(() => {
    if (!isRequested) return
    dispatch(viewActions.setFiltersFocus(null))
    onFocusEvent()
  }, [dispatch, isRequested])

  return isRequested
}
